module.exports = __webpack_public_path__ + "static/img/zhutuSAD300.0242d5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type2-2/zhutuSAD300.png
// module id = r9MU
// module chunks = 0